<template>
    <div class="container-fluid">
        <div class="row" :visibility="loading?'hidden':'visible'">
            <div class="col-3">
                <LeftPanel v-if="$store.state.userid"
                        :bucketname="bucketname"
                        :lawcase-id="Number(openInfo.lawcaseId)"
                        :openInfo="openInfo"
                        :maxPage="maxPage"
                        @case-id-changed="lawcaseIdChanged($event)"
                        @document-selected="documentSelected($event)"
                        @document-title-changed="onDocumentTitleChanged($event)"
                        />
            </div>
            <div class="col position-relative">
                <div v-if="documentTitle">
                    <h4>{{documentTitle}}</h4>
                    <h6>{{ openInfo.obj }} ({{ openInfo.page }}/{{ maxPage }})</h6>
                    <div>fileid:{{ openInfo.fileId }}</div>
                </div>
                <!--
                <div class="btn-group position-absolute top-0 end-0">
                    <button class="btn btn-light dropdown-toggle" 
                        type="button" data-toggle="dropdown">
                        <i class="bi bi-three-dots"></i>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#">ドキュメントを登録・編集</a>"
                    </div>
                </div>
                -->
                <PdfPane
                        v-if="openInfo.obj"
                        ref="pdfpane"
                        :bucketname="bucketname"
                        :openInfo="openInfo"
                        :displayOnly="false"
                        :anchors="anchors"
                        @page-changed="pdfPageChanged($event)"
                        @target-selected="anchorSelected($event)"
                        @update-anchors="updateAnchors($event)"
                        @pdf-opened="onPdfOpened($event)"
                        />
                <h4 v-else>ドキュメントを選択してください</h4>
            </div>
            <div class="col-3">
                <RightPanel v-if="$store.state.userid" 
                    class="" :anchors="anchors"
                    @src-selected="srcSelected($event)"
                    :target="target"
                    :showMode="showMode"
                    :bucketname="bucketname"
                    @switch-mode="switchMode($event)"
                    @update-anchors="updateAnchors($event)"
                />
            </div>
        </div>
        <div v-if="loading" id="loading">
            <div class="text-center">
                <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                <h4>Loading...</h4>
                Googleへログインしてることを確認してください。
            </div>
        </div>
    </div>
</template>

<script>
import LeftPanel from "../components/LeftPanel.vue";
import PdfPane from "../components/PdfPane.vue";
import RightPanel from '../components/RightPanel.vue'
import utils from "../utils/utils";

export default {
    name: 'MainView',
    data() {
        return {
            bucketname: '',
            openInfo: {
                lawcaseId: this.$route.query.case,
                obj: this.$route.query.obj,
                page: this.$route.query.page,
                fileId: null
            },
            anchors: [],
            loading: true,
            showMode: 'dst',
            target: null,
            prefix: '',
            documentTitle: '',
            maxPage: -1,
        }
    },
    components: {
        LeftPanel,
        PdfPane,
        RightPanel,
    },
    async mounted(){
        console.log("mounting PDFVIEW")
        if(this.$store.state.gToken && !utils.isTokenExpired()) {
            await this.renewUserId();
        }
        let objname = this.$route.query.obj;
        if(objname){
            let fileId = await this.getFileId(objname);
            this.openInfo = {
                "lawcaseId": this.$route.query.case,
                "obj": objname,
                "page": this.$route.query.page || 1,
                "fileId": fileId
            };
        }
        
        console.log(`PdfView: ${JSON.stringify(this.openInfo)}`);
    },
    methods: {
        async renewUserId() {
            let res = null;
            for(let i = 3; i > 0; i--){
                try {
                    res = await utils.get('/api/login');
                    break;
                } catch(Err) {
                    if(i==1){ throw(Err); } 
                }
            }
            const userid = res['id'];
            this.bucketname = res['bucket'];
            this.$store.commit('userid', userid);
            if(this.openInfo.page){
                await this.updateAnchors(this.openInfo.page);
            }
            this.loading = false;
        },
        lawcaseIdChanged(id) {
            console.log(`lawcaseId changed to ${id}`);
            this.$router.push(`?case=${id}`);
        },
        async documentSelected(docinfo) {
            // this.$router.push(`?case=${this.openInfo.lawcaseId}&obj=${docinfo.path}&page=${docinfo.page + 1}`);
            console.log(`PDFVIEW: documentSelected ${docinfo}`);
            history.replaceState(null, null, `?case=${this.openInfo.lawcaseId}&obj=${docinfo.path}&page=${docinfo.page+1}`);
            let fileId = await this.getFileId(docinfo.path);
            this.$nextTick( async () => {
                this.openInfo = {
                    "lawcaseId": this.openInfo.lawcaseId,
                    "obj": docinfo.path,
                    "page": docinfo.page + 1,
                    "fileId": fileId
                };
                await this.updateAnchors(docinfo.page+1);
            });
        },
        pdfPageChanged(page) {
            console.log(`PDFVIEW: pageChanged ${page}`);
            history.replaceState(null, null, `?case=${this.openInfo.lawcaseId}&obj=${this.openInfo.obj}&page=${page}`);
            // this.$router.push(`?case=${this.openInfo.lawcaseId}&obj=${this.openInfo.obj}&page=${page}`);
            this.$nextTick( async () => {
                let openInfo = Object.assign({}, this.openInfo);
                openInfo.page = page;
                this.openInfo = openInfo;
                await this.updateAnchors(page);
            });
        },
        switchMode(mode) {
            this.showMode = mode;
        },
        async getFileId(objname) {
            let pdfname = objname ? objname.substring(objname.lastIndexOf('/')+1) : '';
            let lawcaseId = this.$route.query.case;
            let gql = `{file(where: {
                    path: {_eq: "${pdfname}"},
                    lawcase_id: {_eq: ${lawcaseId}}
            }) { id }}`
            let fileId = -1;
            try{
                this.loading = true;
                let res = await utils.queryGQL(gql);
                fileId = res['file'].length > 0 ? res['file'][0]['id'] : -1;
            } finally {
                this.loading = false; 
            }
            return fileId;
        },

        async getAnchor(anchorId) {
            if(!anchorId){ return null; }
            const gql = `{
                  anchor(
                    order_by: {id: asc},
                    where: {
                      id: {_eq: ${anchorId}},
                    }
                  ) {
                    id, name, page, position, bounds, snippet, tag, rawtxt, is_reference,
                    document { id, name, lawcase { id, name, path_prefix } },
                    file { path },
                    dst_hyperlinks {
                      dst_anchor {
                        id, name, page, position, bounds, snippet, tag, rawtxt,
                        document { name, lawcase{ id, path_prefix } }, file { path }
                      }
                    },
                    src_hyperlinks {
                      src_anchor {
                        id, name, page, position, bounds, snippet, tag, rawtxt,
                        document { name, lawcase{ id, path_prefix } },
                        file { path }
                      }
                    }
                  }
                }`;
            return (await utils.queryGQL(gql))['anchor'][0];
        },
        async srcSelected(anchorId){
            let target = null;
            if(anchorId){
                console.log("PDFView: ON TARGET Changed -- " + anchorId);
                target = await this.getAnchor(anchorId);
                console.assert(target.is_reference, "!!!! should be reference !!!!")
            }
            this.$nextTick( () => { this.target = target; });

        },
        async anchorSelected(anchorId){
            console.log("PDFView: ON TARGET SELECTED -- " + anchorId);
            let target = await this.getAnchor(anchorId);
            this.$nextTick( () => {
                if(target.is_reference){
                    this.showMode = 'dst';
                } else {
                    this.showMode = 'src';
                }
                this.target = target;
            });
        },
        async updateAnchors(page) {
            if(!page){ page = this.page; }
            console.log(`on update-anchors ${page}`);
            console.assert(!this.displayOnly, "get anchors on diplay only mode");
            if(!this.openInfo.obj){
                return console.log("NO FILE SELECTED");
            }

            const document_path = this.openInfo.obj.split('/', 2)[1];
            const gql = `{
              anchor(
                order_by: {id: asc},
                where: {
                  page: {_eq: ${page - 1}},
                  document: {
                    lawcase: {id: {_eq: ${this.openInfo.lawcaseId}}}
                  },
                  file: {path: {_eq: "${document_path}"}}
                }
              ) {
                id, name, page, position, bounds, snippet, tag, rawtxt, is_reference,
                document { name, lawcase { id, name, path_prefix } },
                file { path },
                dst_hyperlinks {
                  dst_anchor {
                    id, name, page, position, bounds, snippet, tag, rawtxt,
                    document { name, lawcase{ path_prefix } },
                    file { path }
                  }
                },
                src_hyperlinks {
                  src_anchor {
                    id, name, page, position, bounds, snippet, tag, rawtxt,
                    document { name, lawcase{ path_prefix } },
                    file { path }
                  }
                }
              }
            }`;
            this.page = page;
            this.anchors = (await utils.queryGQL(gql))['anchor'].map( a => {
                a['url'] = `/?obj=${encodeURI(a.document.lawcase.path_prefix + '/' + a.file.path)}&page=${a.page}`;
                return a;
            });
        },
        showDocumentEdit() {

        },
        onDocumentTitleChanged(title) {
            this.documentTitle = title;
            this.target = null;
        },
        onPdfOpened(maxPage) {
            this.maxPage = maxPage;
        }
    },
    watch: {
        "$store.state.gToken": async function(newVal) {
            if(newVal) {
                await this.renewUserId();
            }
        },
        $route: async function(newVal) {
            console.log('ROUTER CHANGE')
            console.log(newVal)
            let objname = this.$route.query.obj;
            let fileId = await this.getFileId(objname);
            this.$nextTick( async () => {
                this.openInfo = {
                    "lawcaseId": this.$route.query.case || 0,
                    "obj": objname,
                    "page": this.$route.query.page || 1,
                    "fileId": fileId,
                };
                await this.updateAnchors(this.$route.query.page);
            });
        },
    },
}
</script>


<style scoped>
.pdf-section {
    height: 93vh;
    padding: 1rem;
    margin-bottom: 1rem;
    border: 1px solid;
    border-radius: 5px;
    overflow-y: overlay;
}
#loading {
    position: absolute;
    top: 50%;
    width:100%;
}
</style>
